import { jsonb, pgEnum, pgTable, text, timestamp, unique, uuid, vector } from 'drizzle-orm/pg-core';

import { candidates } from './candidates';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const cvStatusEnum = pgEnum('cv_status', ['pending', 'processing', 'done', 'failed']);

export const candidateProfiles = pgTable(
  'candidate_profiles',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    storageKey: text('storage_key').notNull(),
    status: cvStatusEnum('status').notNull(),
    parsedData: jsonb('parsed_data'),
    dataToProcess: jsonb('data_to_process'),
    embedding: vector('embedding', { dimensions: 1536 }),
    uploadedAt: timestamp('uploaded_at', { withTimezone: true }).notNull().defaultNow(),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true })
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    unique('candidate_profiles_candidate').on(t.tenantId, t.orgId, t.candidateId),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
